import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, EventEmitter } from '@angular/core';
import { ControlComponentBase } from '../../common/control-component-base';
import { UniqueId } from '../../common/unique-id';
import { SessionService } from '../../services/session/session.service';
import { NumericTextBoxOptions } from './numeric-text-box-options';
var NumericEditComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NumericEditComponent, _super);
    function NumericEditComponent(elementRef, sessionService, changeDetectorRef) {
        var _this = _super.call(this, elementRef, changeDetectorRef) || this;
        _this.sessionService = sessionService;
        _this.validationMessage = '';
        _this.option = { min: 0, step: 1, spinners: false };
        _this.disable = false;
        _this.isSpecialLabel = false;
        _this.helpTooltip = '';
        _this.helpIcon = 'Help';
        _this.isOpenLink = true;
        _this.isNotNegativeValue = false;
        _this.maxHeight20 = '';
        _this.addOnButtonEdit = false;
        _this.addOnButtonEditTooltip = '';
        _this.addOnButtonEditClass = '';
        _this.addOnButtonEditClassFormControl = '';
        _this.addOnButtonEditAction = '';
        _this.addOnButtonEditDisabled = false;
        _this.addOnButtonEditIcon = '';
        _this.addOnButtonEditLabel = '';
        _this.addOnButtonEditIconEnable = false;
        _this.keyList = { 17: false, 40: false, 38: false };
        _this.blur = new EventEmitter();
        _this.keydowns = new EventEmitter();
        _this.keyup = new EventEmitter();
        _this.addOnButtonClick = new EventEmitter();
        _this.componentId = 'NumericTextBoxComponent' + UniqueId();
        return _this;
    }
    NumericEditComponent.prototype.valid = function () {
        if (this.required && (!this.value || this.value.length === 0)) {
            return false;
        }
        if (this.value && !this.sessionService.parseFloat(this.value)) {
            return false;
        }
        return true;
    };
    NumericEditComponent.prototype.onBlur = function () {
        this.blur.emit();
    };
    NumericEditComponent.prototype.onvalueChange = function (value) {
        if (value && value < 0 && this.isNotNegativeValue) {
            value = value * -1;
            this.value = value;
        }
    };
    NumericEditComponent.prototype.onKeydown = function (key) {
        if (key.key === 'ArrowUp' || key.key === 'ArrowDown') {
            if (this.isGrid && (this.value || this.value === 0) && this.option && this.option.step) {
                if (key.key === 'ArrowUp') {
                    this.value -= this.option.step;
                }
                else {
                    this.value += this.option.step;
                }
                if ((this.baseValues === null || this.baseValues === undefined) && this.value === 0) {
                    this.value = this.baseValues;
                }
            }
        }
        if (key.keyCode === 27) {
            // Escape
            this.value = this.original;
        }
    };
    NumericEditComponent.prototype.onKeyup = function (key) {
        this.keyup.emit(key);
    };
    NumericEditComponent.prototype.onFocus = function () { };
    NumericEditComponent.prototype.addOnButtonEditClick = function () {
        this.addOnButtonClick.emit(this.addOnButtonEditAction);
    };
    return NumericEditComponent;
}(ControlComponentBase));
export { NumericEditComponent };
